// extracted by mini-css-extract-plugin
export default {"cls1":"kQ83ArOm3BKHYSJvgyAw","cls2":"j31789sTx82ofLWb8G_W kQ83ArOm3BKHYSJvgyAw"};